import App from '../app/App.js';
import LandingPage from '../pages/LandingPage.js';
import Page from '../pages/Page.js';
import LandingLayout from '../app/LandingLayout.js';

import NavbarController
    from '../components/sections/Navbar/NavbarController';

import ProgrammeController
    from '../pages/Programme/ProgrammeController.js';

import { initAnimation }
    from '../animations/Animation';

export default async function Router() {

    const base = import.meta.env.BASE_URL;

    const path =
        window.location.pathname.replace(base, '/');

    const app = new App();

    const conference =
        await app.loadConference();

    const layout =
        conference.settings?.site?.layout || 'onepage';


    /*
     * ONEPAGE
     */

    if (layout === 'onepage') {

        await app.init();

        return;
    }


    /*
     * LANDING / MULTI PAGE
     */

    const element =
        document.getElementById('app');
	
	element.classList.toggle(
    'landing-subpage',
    path !== '/'
	);
	
    let content;


    switch (path) {

        case '/':
            content = LandingPage({
                conference
            });
            break;

        case '/about':
            content = Page('about', conference);
            break;

        case '/speakers':
            content = Page('speakers', conference);
            break;

        case '/committee':
            content = Page('committee', conference);
            break;

        case '/programme':
            content = Page('programme', conference);
            break;

        case '/venue':
            content = Page('venue', conference);
            break;

        case '/partners':
            content = Page('partners', conference);
            break;

        default:
            content = `
                <section class="page-not-found">
                    <div class="container">
                        <h1>Page not found</h1>
                    </div>
                </section>
            `;
    }


    element.innerHTML =
        LandingLayout(content, conference);


    /*
     * Uruchamiamy kontrolery również
     * na stronach landingowych.
     */

    initAnimation();

    NavbarController();

    ProgrammeController(conference);
}
